module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAcCAYAAAB75n/uAAAAAXNSR0IArs4c6QAAAMlJREFUSInt1LsRwyAQRdHH0AE1UIgzlSUoiyFxIdRACzixNML8diXI/EJmuCdbgDHv/e6c2zl/BCeeUjIAkFIy27bZacA1foyKDIFanIN0gV6cijQBSpyCVAFOfIQUwJ14D8mAJ/EWcgIz4jVEzI7/ImJF/Iqs6P7Hm9BaGwCsG8+YlTHGt1JKAHjNjocQjASABYgNIRgAkMfLROSMZ8AkJIsXwEOkiFeBm0g13gSYSDPeBYhINz4EBsgwTgIaCCnOntbafE8LeR/hG8zPFl23jwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/sort-smallest.png
// module id = QukL
// module chunks = 1